'use client';
import { TourProvider } from '@reactour/tour';
import { getSteps } from './steps';
import { useTranslation } from 'react-i18next';
import { TourPersistence } from './TourPersistence';
import { useSkipUnavailableSteps } from './useSkipUnavailableSteps';

function TourContent({ children }: { children: React.ReactNode }) {
  useSkipUnavailableSteps();
  return <>{children}</>;
}

export default function TourClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation();

  // Build steps (no filtering at provider level)
  const steps = getSteps(t);

  return (
    <TourProvider
      steps={steps}
      showBadge={false}
      scrollSmooth
      startAt={
        typeof window !== 'undefined'
          ? parseInt(localStorage.getItem('samplesTourStep') || '0')
          : 0
      }
      styles={{
        popover: (base) => ({
          ...base,
          borderRadius: 6,
          '--reactour-accent': '#FFFFFF',
          color: '#FFFFFF',
          maxWidth: '372px',
          background: 'linear-gradient(45deg, #0c8ce9, #00b8db)',
        }),
        highlightedArea: (base) => ({ ...base.style, rx: 16, ry: 16 }),
        maskArea: (base) => ({ ...base, rx: 6 }),
        maskWrapper: (base) => ({ ...base, color: '#a3a3a3' }),
        badge: (base) => ({
          ...base,
          color: '#FFFFFF',
          background: '#000000',
          borderRadius: 50,
          boxShadow: 'none',
          left: 'auto',
          right: '-0.8125em',
        }),
      }}
    >
      <TourPersistence stepsLength={steps.length} />
      <TourContent>{children}</TourContent>
    </TourProvider>
  );
}
